import {Modal, Space} from "antd";
import {ReactNode} from "react";

export const EmbeddingErrorMessage = (props: {
    content: ReactNode | string,
    onUnmbedClick: () => void,
    loading: boolean,
    onClose: () => void

}) => {
    return (
        <Modal
            open={true}
            title={'Embedding Error'}
            cancelText={'Cancel'}
            okText={'Un-embed'}
            okButtonProps={{danger: true, loading: props.loading}}
            onCancel={props.onClose}
            onOk={props.onUnmbedClick}
        >
            <Space direction={'vertical'}>
                <div style={{whiteSpace:'pre-wrap'}}>{props.content}</div>
            </Space>
        </Modal>
    )
}